import { BaseRepository } from "@/repositories/base-repository"
import { type IProjectPurchaseItem } from "@/interfaces/api/project-purchase-item.interface"

export class ProjectPurchaseItemRepository extends BaseRepository<IProjectPurchaseItem> {
  protected resourcePath = "administration/projects-purchase-items"
}
